import request from "../utils/request";

// https://yapi.gaoding.com/project/1536/interface/api/126449
/**
 * 大赛列表
 * @param {page} number 当前页
 * @param {per_page} number 每页数量
 * @returns
 */
export async function fetchActivities({ page = 1, limit = 10 } = {}) {
  return request({
    url: "/activities",
    method: "get",
    query: {
      page,
      per_page: limit,
    },
  });
}

// https://yapi.gaoding.com/project/1536/interface/api/150280
/**
 * 发起大赛
 */
export async function startActivities({
  activity_type,
  activity_budget,
  activity_background,
  company,
  mobile,
  name,
  source,
  leads_entrance,
}) {
  return request({
    url: "/crm/leads/create",
    method: "post",
    data: {
      activity_type,
      activity_budget,
      activity_background,
      company,
      mobile,
      name,
      source,
      leads_entrance,
    },
  });
}
